import { merge } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { useToast, Box, Flex } from '@chakra-ui/react'
import React, { useMemo, useState, useCallback } from 'react'

import { Wizard, WizardBreadcrumb, WizardOutlet } from 'components'

import { useUserRegisterMutation } from '../../hooks'

import UserRegistrationStep1 from './UserRegistrationStep1'
import UserRegistrationStep2 from './UserRegistrationStep2'
import UserRegistrationStep3 from './UserRegistrationStep3'
import UserRegistrationStep4 from './UserRegistrationStep4'
import UserRegistrationStep5 from './UserRegistrationStep5'

export const UserRegistration = props => {
  const toast = useToast()
  const navigate = useNavigate()
  const [userRegisterMutation] = useUserRegisterMutation()

  const steps = useMemo(
    () => [
      {
        name: 'start',
        path: 'inicio',
        label: 'Início',
        element: <UserRegistrationStep1 />
      },
      {
        name: 'user',
        path: 'utilizador',
        label: 'Dados do Utilizador',
        element: <UserRegistrationStep2 />
      },
      {
        name: 'entity',
        path: 'entidade',
        label: 'Dados da Entidade',
        element: <UserRegistrationStep3 />
      },
      {
        name: 'project',
        path: 'projeto',
        label: 'Dados do Projeto',
        element: <UserRegistrationStep4 />
      },
      {
        name: 'end',
        path: 'fim',
        label: 'Fim de Registo',
        element: <UserRegistrationStep5 />
      }
    ],
    []
  )

  const [data, setData] = useState({
    user: {
      agree: false,
      experience: null
    },
    entity: {
      sector: null,
      onEntityBehalf: null
    },
    project: {
      name: null,
      sectors: [],
      stage: null,
      goals: null,
      expectedResults: null,
      application: null,
      techniques: [],
      phase: null,
      target: null,
      impact: null,
      technologies: [],
      technologiesEmerging: []
    }
  })
  const handleStep = useCallback(data => setData(prev => merge(prev, data)), [setData])
  const handleFinish = useCallback(async () => {
    const { data: errors } = await userRegisterMutation({ userRegister: data })
    if (errors && errors.length > 1) {
      toast({
        status: 'error',
        title: 'Registo bem sucedido.',
        description: 'O registo de utilizador foi efetuado com sucesso.'
      })
    } else {
      toast({
        status: 'success',
        title: 'Registo bem sucedido.',
        description: 'O registo de utilizador foi efetuado com sucesso.'
      })
      navigate('/acesso')
    }
  }, [data, toast, navigate, userRegisterMutation])

  return (
    <Wizard data={data} steps={steps} onStep={handleStep} onFinish={handleFinish}>
      <Box align='center' p={3} borderBottomWidth='1px'>
        <WizardBreadcrumb />
      </Box>
      <Flex flex={1}>
        <WizardOutlet />
      </Flex>
    </Wizard>
  )
}

export default UserRegistration
